import { z } from "zod";
import { customErrorMap } from "../services/zodService";
import { DocumentSettingsSchema } from "./document-settings";
import { documentStatusSchema } from "./types";


z.setErrorMap(customErrorMap);


export const EntryDocumentSchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    account_id: z.number(),
    document_settings_id: z.number(),

    created_at: z.string().optional(),
    updated_at: z.string().optional(),


    document_number: z.number(),
    date_time: z.string(),
    status: documentStatusSchema,
    


    // nullable
    works_total: z.number().nullable(),
    items_total: z.number().nullable(),
    discount: z.number().nullable(),
    total: z.number().nullable(),
    vat: z.number().nullable(),
    to_pay: z.number().nullable(),
    balance: z.number().nullable(),
    reference: z.string().nullable(),

    
    // loads
    document_settings: DocumentSettingsSchema.optional(),

});
